(function() {
    'use strict';
 
a3_pilot_reports.factory('AirportContactFactory',AirportContactFactory);
 
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name AirportContactFactory
    * @description 
    *   Add, Update, Delete and Get Airport Contacts.
    * @ngInject
    */
function AirportContactFactory(GenericService){
    
        /**
        * Initialize the AirportContact
        * @memberof AirportContactFactory
        */
		function Airport() {
            this.Iata=null;
            this.Contacts=null;
        }
                
		var objType = 'airportContacts';
		var objCallback = Airport; 

		var service = 
		{  
			fromObjectList : fromObjectList,
			getAirportContactsFromStorage : getAirportContactsFromStorage,
			setAirportContactsToStorage : setAirportContactsToStorage,
            clearAirportContactsFromStorage : clearAirportContactsFromStorage,
            getAirportContacts: getAirportContacts,
            upsertAirportContacts: upsertAirportContacts
		};

        /**
         * Extend an array of Objects from the default airportContact Object
         * @memberof AirportContactFactory
         * @param {Array} objList  an Array Of airportContact
         * @returns {Array} airportContact
         */
		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList,objCallback);
		}
    
        /**
         * Get airportContacts
         * @memberof AirportContactFactory
         * @returns {Array} airportContacts
         */
		function getAirportContactsFromStorage() {
			return GenericService.list(objType,objCallback);
		}
    
        /**
         * Save airportContacts to storage
         * @memberof AirportContactFactory
         * @param {Array} airportContacts A list of AirportContacts
         */
		function setAirportContactsToStorage(airportContacts) {
			GenericService.saveAll(airportContacts,objType,objCallback);
		}
    
        /**
         * Remove the airportContacts of  the local storage
         * @memberof AirportContactFactory
         */
		function clearAirportContactsFromStorage() {
			GenericService.removeAll(objType,objCallback);
        }
    
        /**
         * Get the contacts for a given airport
         * @memberof AirportContactFactory
         */
		function getAirportContacts(airportIata) {
            var all = this.getAirportContactsFromStorage();
            if (!all) return null;
            var airport = all.filter(function(item){return item.Iata == airportIata;});
            if (!airport || airport.length == 0) return null;
            //we expect a single airport item per iata
            return airport[0];
            //return GenericService.fromObjectList(airport[0].Contacts, Contact);
        }

         /**
         * Upsert airport contacts
         * @memberof AirportContactFactory
         */
          function upsertAirportContacts(airportContacts){
            var newStations = airportContacts.map(x=>x.Iata);
            var contactsLS = this.getAirportContactsFromStorage();
            contactsLS = contactsLS.filter(x => !newStations.includes(x.Iata));
            var updatedContactList = contactsLS.concat(airportContacts);
            setAirportContactsToStorage(updatedContactList);
       }
        
	return service;
	}

 
 })();   